import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import AdvisorDetails from './AdvisorDetails';
import AdvisorReviews from './AdvisorReviews';
import LoadingComponent from '../components/widgets/LoadingComponent';
import useAdvisor from '../hooks/useAdvisor';

function AdvisorProfile() {
  const { advisorId } = useParams();
  const { authState } = useContext(AuthContext);
  const { advisor, setAdvisor, hasUserReview, isLoading } = useAdvisor(advisorId);

  const canReview =
    authState.isAuthorized && advisor && authState.school.id === advisor.school;

  if (isLoading) return <LoadingComponent />;
  if (!advisor) return <div>No advisor data</div>;

  return (
    <>
      <AdvisorDetails advisor={advisor} setAdvisor={setAdvisor} canEdit={canReview} />
      <AdvisorReviews
        advisorId={advisorId}
        canReview={canReview}
        hasUserReview={hasUserReview}
        reviews={advisor.reviews || []}
      />
    </>
  );
}

export default AdvisorProfile;
